import { Col, Row } from 'antd';
import React from 'react';
import SectionLayout from '../../CommonComponents/Layout/sectionLayout';
import SponsorOptionPageHeroText from '../../CommonComponents/SponsorOptionPageHeroText';
import Highlights from './Highlights';
import useLocalization from '../../../Localization';

const CareerMentorshipComponent = ({ data }) => {
  const { ApplicationString } = useLocalization();
  const CareerMentorshipComponentHTML = data?.career_mentorship;
  return (
    <React.Fragment>
      <Row gutter={[0, 30]} className='pbssMainContainerRow'>
        <Col span={24}>
          <SponsorOptionPageHeroText
            title={ApplicationString['careerMentorshipComponent.title']}
            subTitle={ApplicationString['pbss.generalInformation.subtitle']}
          />
        </Col>
        <Col span={24}>
          <SectionLayout>
            <div
              dangerouslySetInnerHTML={{
                __html: CareerMentorshipComponentHTML,
              }}></div>
          </SectionLayout>
        </Col>
        <Col span={24}>
          <Highlights data={data} />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default CareerMentorshipComponent;
